/** Bảng NPC M3: danh sách, thân thiết, tặng quà, hội thoại. */
import { useState } from 'preact/hooks';
import {
  capThanThiet,
  hoiThoaiKhaDung,
  layNoiDungNpc,
  npcDaMo,
  quaCanDeLenCap,
} from '../../core/npc.js';
import type { GameController } from '../game-controller.js';
import { styleNutChinh, stylePanel, useCapNhat } from '../dung-chung.js';
import { toast } from './Toast.js';

const NHAN_VAI_TRO: Record<string, string> = {
  nhaCungCap: '🏭 Nhà cung cấp',
  khachQuen: '😊 Khách quen',
  hangXom: '🏘️ Hàng xóm',
};

export function PanelNpc(props: { controller: GameController }) {
  const { controller } = props;
  useCapNhat(controller);
  const { state, duLieu } = controller;
  const [npcChon, setNpcChon] = useState<string | null>(null);

  const ds = npcDaMo(state, duLieu);
  const npc = ds.find((n) => n.ma === npcChon) ?? null;

  const bamTangQua = (ma: string): void => {
    try {
      const kq = controller.tangQuaChoNpc(ma);
      if (kq.lenCap) {
        toast(`Thân thiết tăng lên cấp ${kq.capMoi}! 💛 (+XP)`);
      } else {
        toast('Đã tặng quà! 🎁');
      }
    } catch (e) {
      toast(e instanceof Error ? e.message : 'Không tặng được.');
    }
  };

  return (
    <div style={stylePanel}>
      <h3 style={{ margin: '0 0 8px' }}>👥 Người quen</h3>
      {!npc && (
        <div>
          {ds.map((n) => {
            const nd = layNoiDungNpc(duLieu, n.ma);
            const cap = capThanThiet(state, n.ma);
            return (
              <button
                key={n.ma}
                onClick={() => setNpcChon(n.ma)}
                style={{
                  display: 'block',
                  width: '100%',
                  textAlign: 'left',
                  background: 'transparent',
                  border: '1px solid #8a6a3a',
                  borderRadius: '8px',
                  padding: '8px',
                  marginBottom: '6px',
                  color: '#f5e9d0',
                  cursor: 'pointer',
                }}
              >
                <div style={{ fontWeight: 700 }}>{nd.ten}</div>
                <div style={{ fontSize: '12px', opacity: 0.8 }}>
                  {NHAN_VAI_TRO[n.vaiTro] ?? n.vaiTro}
                  {n.vaiTro === 'khachQuen' &&
                    ` — thân thiết ${'💛'.repeat(cap)}${'🤍'.repeat(5 - cap)}`}
                </div>
              </button>
            );
          })}
        </div>
      )}
      {npc && (
        <div>
          <button style={styleNutChinh} onClick={() => setNpcChon(null)}>
            ← Danh sách
          </button>
          {(() => {
            const nd = layNoiDungNpc(duLieu, npc.ma);
            const cap = capThanThiet(state, npc.ma);
            const thoai = hoiThoaiKhaDung(state, duLieu, npc.ma);
            const cau = thoai.length > 0 ? thoai[Math.floor(Math.random() * thoai.length)]! : null;
            return (
              <div style={{ marginTop: '8px' }}>
                <h4 style={{ margin: '0 0 4px' }}>{nd.ten}</h4>
                <p style={{ fontSize: '13px', opacity: 0.85, margin: '0 0 8px' }}>{nd.moTa}</p>
                {npc.vaiTro === 'khachQuen' && (
                  <p style={{ fontSize: '13px' }}>
                    Thân thiết: {'💛'.repeat(cap)}
                    {'🤍'.repeat(5 - cap)} (cấp {cap}/5)
                  </p>
                )}
                {cau && (
                  <div
                    style={{
                      background: '#2a2014',
                      borderRadius: '8px',
                      padding: '8px',
                      fontSize: '14px',
                      fontStyle: 'italic',
                      marginBottom: '8px',
                    }}
                  >
                    “{cau.text}”
                  </div>
                )}
                {npc.vaiTro === 'khachQuen' && cap < 5 && (
                  <div>
                    <div style={{ fontSize: '13px', marginBottom: '4px' }}>
                      Quà ưa thích: {npc.quaUaThich} (cần {quaCanDeLenCap(state, duLieu, npc.ma)} để
                      lên cấp {cap + 1})
                    </div>
                    <button style={styleNutChinh} onClick={() => bamTangQua(npc.ma)}>
                      🎁 Tặng quà
                    </button>
                  </div>
                )}
              </div>
            );
          })()}
        </div>
      )}
    </div>
  );
}
